window.addEventListener('load', () => {
    $jq('.slideshow').slick({
        speed: 500,
        centerMode: true,
        slidesToShow: 1,
        centerPadding: '170px',
        prevArrow: $jq('.btn--prev'),
        nextArrow: $jq('.btn--next'),
        variableWidth: true,
        responsive: [{

            breakpoint: 1200,
            settings: {
                centerPadding: '50px',
            }

        }, {

            breakpoint: 768,
            settings: {
                centerPadding: '35px',
            }
        }, {

            breakpoint: 360,
            settings: {
                centerPadding: '15px',
            }
        }]
    });

    const slideshowContainer = $jq('.slideshow-container')
    $jq('.article-slideshow').replaceWith(slideshowContainer)
    slideshowContainer.removeClass('d-none')

    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(function (_, observer) {
        observer.disconnect()
    });
    if(!slideshowContainer[0]) return
    observer.observe(slideshowContainer[0], config);
})
